'use strict';

module.exports = function (fox) {
	var servicesCtx = require.context('./lib/services', false, /\.js$/);

	function getDeps (context) {
		context.keys().forEach(function (m) {
			context(m)(fox);
		});
	}

	getDeps(servicesCtx);
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-services/index.js
// module id = 238
// module chunks = 0